import React from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { AlertBox } from "../../../../shared/AlertBox/AlertBox";

export function Deleted() {
  var { tSurvey: t } = useAppTranslation.Survey();
  return <AlertBox center>{t("deleted")}</AlertBox>;
}
